"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCourseCurriculumRefined = void 0;
const __1 = require("..");
const buildCourseCurriculumRefined = (course, programs, deliveries, subjectPrograms) => ({
    ID: course.ID,
    metadata: {
        created: course.metadata.created,
        updated: course.metadata.updated,
    },
    type: course.type,
    code: course.code,
    name: course.name,
    cricosCodes: course.cricosCodes,
    levels: course.levels,
    cohorts: course.cohorts,
    url: course.url,
    creditPoints: course.creditPoints,
    customAttributes: course.customAttributes,
    programs: programs.map((program) => (0, __1.buildProgramCurriculumRefined)(program, deliveries.filter((delivery) => delivery.program.ID === program.ID), subjectPrograms.filter((subjectProgram) => subjectProgram.program.ID === program.ID))),
});
exports.buildCourseCurriculumRefined = buildCourseCurriculumRefined;
//# sourceMappingURL=CourseRefined.js.map